import React from 'react';
import SelectForCountryCodes from './Selectors/SelectForCountryCodes';

class PhoneNumberInputField extends React.Component {
  static defaultProps = {
    value: '',
    onChange: () => {},
    className: 'w-100',
    fieldName: 'defaultFieldname',
    placeholder: 'Enter phone number',
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {}

  getParts(value) {
    if (value === undefined) return '';
    if (!value.includes(')-')) value = ')-' + value;
    if (!value.includes('/')) value += '/';
    let parts = value.split(')-');

    let numbers = parts[1].split('/');
    parts[1] = numbers[0];
    parts[2] = numbers[1];
    parts[0] += ')';
    return parts;
  }

  changeHandler(country, number, ext) {
    if (country === ')') country = '';
    let result = country ? `${country}-${number}` : `${number}`;
    result = ext ? `${result}/${ext}` : result;
    this.props.onChange(result);
  }

  render() {
    let parts = this.getParts(this.props.value);
    let ccode = parts[0];
    let num = parts[1];
    let ext = parts[2];

    return (
      <div className={'d-flex ' + this.props.className.replaceAll('form-control', '').replaceAll('-sm', '')}>
        <SelectForCountryCodes
          value={parts[0]}
          onChange={(e) => {
            this.changeHandler(e.target.value, parts[1], parts[2]);
          }}
        />
        <input
          type='text'
          className={'form-control form-control-sm'}
          placeholder={this.props.placeholder}
          value={num}
          onChange={(e) => {
            let numberstr = e.target.value;
            numberstr = numberstr.replaceAll(/[^0-9]/g, '');
            if (numberstr.substr(0, 1) === '0') {
              numberstr = numberstr.substring(1);
            }

            this.changeHandler(ccode, numberstr, ext);
          }}
          id={'htmlidfor' + this.props.fieldName + 'num'}
          autoComplete='off'
        />
        <span
          className='btn btn-info btn-sm form-control-orange '
          onClick={() => {
            this.props.onChange(this.props.fieldName, this.defaultValue());
          }}
        >
          <i className='fa-solid fa-eraser' />
        </span>
        <div className='ml-4 mr-4 text-center'> Ext. </div>
        <input
          type='text'
          className={'form-control form-control-sm'}
          placeholder={this.props.placeholder}
          value={ext}
          onChange={(e) => {
            let numberstr = e.target.value;
            numberstr = numberstr.replaceAll(/[^0-9]/g, '');
            if (numberstr.substr(0, 1) === '0') {
              numberstr = numberstr.substring(1);
            }

            this.changeHandler(ccode, num, numberstr);
          }}
          id={'htmlidfor' + this.props.fieldName + 'ext'}
          autoComplete='off'
        />
      </div>
    );
  }
}

export default PhoneNumberInputField;
